import { render, staticRenderFns } from "./MyCampaignsPage.vue?vue&type=template&id=12817c55"
import script from "./MyCampaignsPage.vue?vue&type=script&lang=js"
export * from "./MyCampaignsPage.vue?vue&type=script&lang=js"
import style0 from "./MyCampaignsPage.vue?vue&type=style&index=0&id=12817c55&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports